import React from 'react';
import Grid from "@material-ui/core/Grid";
import RefreshIcon from "@mui/icons-material/Refresh";
import LastRefreshTimer from './LastRefreshTimer';
import { keyframes } from '@emotion/react';

const spin = keyframes`
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
`;

const Dashboard = ({
    householdData = {},
    lastRefreshAt = null,
    loaderCommission = false,
    onRefresh = () => {},
}) => {
    const formatMoney = (value) => (value || value === 0 ? `$${value}` : '-');
    
    const sectionHeaderStyle = { 
        color: '#4a4a4a', 
        fontSize: 13, 
        fontWeight: 700, 
        letterSpacing: 0.5, 
        marginRight: 14, 
        whiteSpace: 'nowrap', 
        flexShrink: 0 
    };
    
    const sectionLineStyle = { 
        borderTop: '2px solid #e7e7f2', 
        flex: 1 
    };
    
    const statLabelStyle = { 
        color: '#6a6b73', 
        fontSize: 16, 
        lineHeight: '1.05', 
        fontWeight: 400, 
        minHeight: 50,
        letterSpacing: 0.3,
        fontFamily: 'Roboto, Arial, sans-serif',
    };
    
    const statValueStyle = { 
        color: '#222', 
        fontSize: 30, 
        lineHeight: '1', 
        fontWeight: 300, 
        letterSpacing: 0.2,
        // fontFamily: 'Roboto, Arial, sans-serif',
    };

    // Helper to display value as requested
    const displayStat = (val) => {
        if (val === undefined || val === null) return "-";
        if (val === 0) return "0";
        return val;
    };

    return (
        <div style={{ backgroundColor: "#d5d6e9", minHeight: "calc(100vh - 265px)", padding: "10px 18px 20px 18px" }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 10 }}>
                <div style={{ width: '100%' }} />
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: 26, marginTop: 4 }}>
                    <div style={{ textAlign: 'center', minWidth: 108 }}>
                        <div
                            style={{
                                width: 40,
                                height: 40,
                                borderRadius: '50%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                margin: '0 auto',
                                cursor: 'pointer',
                                backgroundColor: '#2F3192',
                                boxShadow: '0 2px 8px 0 rgba(44,49,146,0.10)',
                                transition: 'background 0.2s',
                            }}
                            onClick={() => (loaderCommission ? {} : onRefresh())}
                        >
                            <RefreshIcon sx={{ 
                                fontSize: 23, 
                                color: '#fff', 
                                fontWeight: 700,
                                animation: loaderCommission ? `${spin} 1s linear infinite` : 'none',
                                transformOrigin: 'center',
                            }} />
                        </div>
                        <div style={{ color: '#4c4f9f', fontSize: 10, lineHeight: '12px', marginTop: 5, fontWeight: 600, letterSpacing: 0.5, fontFamily: 'Roboto, Helvetica, Arial, sans-serif', whiteSpace: 'nowrap' }}>
                            LAST REFRESH
                        </div>
                        <div style={{ color: '#4c4f9f', fontSize: 10, lineHeight: '1.15', fontWeight: 600, whiteSpace: 'nowrap', fontFamily: 'Roboto, Helvetica, Arial, sans-serif', whiteSpace: 'nowrap' }}>
                            <LastRefreshTimer lastRefreshAt={lastRefreshAt} />
                        </div>
                    </div>
                </div>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', marginBottom: 20 }}>
                <div style={sectionHeaderStyle}>TO DATE</div>
                <div style={sectionLineStyle} />
            </div>

            <Grid container style={{ marginBottom: 60 }}>
                <Grid item xs={12} sm={2}>
                    <div style={statLabelStyle}>Total<br/>Prospects</div>
                    <div style={statValueStyle}>{displayStat(householdData.prospectCount)}</div>
                </Grid>
                <Grid item xs={12} sm={2}>
                    <div style={statLabelStyle}>Completed<br/>Enrollments</div>
                    <div style={statValueStyle}>{displayStat(householdData.enrollCount)}</div>
                </Grid>
                <Grid item xs={12} sm={2}>
                    <div style={statLabelStyle}>In-Progress<br/>Enrollments</div>
                    <div style={statValueStyle}>{displayStat(householdData.notEnrollCount)}</div>
                </Grid>
                <Grid item xs={12} sm={2}>
                    <div style={statLabelStyle}>Active<br/>Members</div>
                    <div style={statValueStyle}>{displayStat(householdData.activeCount)}</div>
                </Grid>
                <Grid item xs={12} sm={2}>
                    <div style={statLabelStyle}>Terminated<br/>Members</div>
                    <div style={statValueStyle}>{displayStat(householdData.terminatedCount)}</div>
                </Grid>
            </Grid>

            <Grid container>
                <Grid item xs={12} sm={3}>
                    <div style={statLabelStyle}>Total Monthly Share<br/>Prospected</div>
                    <div style={statValueStyle}>{formatMoney(householdData.prospectedAmount)}</div>
                </Grid>
                <Grid item xs={12} sm={3}>
                    <div style={statLabelStyle}>Total Monthly Contribution<br/>Enrolled</div>
                    <div style={statValueStyle}>{formatMoney(householdData.enrollAmount)}</div>
                </Grid>
                <Grid item xs={12} sm={3}>
                    <div style={statLabelStyle}>Total Monthly Share<br/>In Progress</div>
                    <div style={statValueStyle}>{formatMoney(householdData.notEnrollAmount)}</div>
                </Grid>
            </Grid>
        </div>
    );
};

export default Dashboard;
